import { useErrorHandling } from '@rd-web-markets/shared/dist/hooks/useErrorHandling';
import { buildService } from '@rd-web-markets/shared/dist/services/service';
import { useCallback, useEffect, useState } from 'react';
import * as QueryString from 'query-string';
import { useHistory, useLocation } from 'react-router-dom/cjs/react-router-dom.min';
const api = buildService('/lists/claim_groups/{id}/claim_project_reports', {
  only: ['all']
});
const claimProjectReportsListsService = {
  base: api,
  useFetchProjects: claimGroupId => {
    const getAll = useErrorHandling(useCallback(async params => {
      const response = await api.all(claimGroupId, params);
      return response;
    }, [claimGroupId]));
    return [getAll];
  },
  useFetchAll: _ref => {
    let {
      accountType,
      claimGroupId,
      initialQueryParams = '',
      setLoading,
      groupProjects = false,
      fetchImmediatelly = true,
      updateUrl = true,
      usePageFromUrl = true
    } = _ref;
    const history = useHistory();
    const location = useLocation();
    const [projects, setProjects] = useState([]);
    const [totalPages, setTotalPages] = useState(null);
    const [totalCostSum, setTotalCostSum] = useState(null);
    const [totalQeSum, setTotalQeSum] = useState(null);
    const [queryParams, setQueryParams] = useState(() => {
      const parsed = {
        ...QueryString.parse(location.search || initialQueryParams),
        group_projects: groupProjects
      };
      if (!usePageFromUrl) delete parsed.page;
      return parsed;
    });
    const fetchAllProjetcs = useErrorHandling(useCallback(async queryParams => {
      setLoading && setLoading(true);
      const projects = await api.all(claimGroupId, queryParams);
      setTotalPages(projects.pages);
      setProjects(projects.claim_project_reports);
      setTotalCostSum(projects.total_cost_sum);
      setTotalQeSum(projects.total_qe_sum);

      // when it is at document level it sometimes push history which makes folder management to make a false call to api without id and model in url params
      // this happens when the above service call is slightly delayed and user nabigates to project > document tab quickly. 
      if (Object.fromEntries(new URL(window.location).searchParams)?.key !== 'documents' && updateUrl) {
        history.push({
          path: `${accountType}/claims`,
          search: QueryString.stringify(queryParams)
        });
      }
      return projects;
    }, [accountType, claimGroupId, history, setLoading, updateUrl]), useCallback(() => {
      setLoading && setLoading(false);
    }, [setLoading]));
    useEffect(() => {
      if (fetchImmediatelly) {
        claimGroupId && fetchAllProjetcs(queryParams);
      }
    }, [fetchAllProjetcs, queryParams, claimGroupId, fetchImmediatelly]);
    return [projects, setProjects, totalPages, setTotalPages, queryParams, setQueryParams, fetchAllProjetcs, totalCostSum, totalQeSum];
  }
};
export default claimProjectReportsListsService;